import { format } from 'date-fns'

import { IRange } from 'store/modules/report/types'

export const getReportExportDates = ({ from, to }: IRange) => ({
  from: format(from, 'dd-MM-yyyy'),
  to: format(to, 'dd-MM-yyyy')
})
